import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

// async function me (username) {
async function me () {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getMe)
      }, 500)
    })
  } else {
    const req = {
      url: 'api/usuarios/getdetalle',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      // params: {
      //   nombre: username
      // }
    }

    const res = await axiosInstance(req)
    return res.data
  }
}

export { me }
